<template>
    <div class="gallery component">
        <div class="grid grid-cols-12">
            <div class="col-span-6 md:col-span-4" :class="{'last:md:col-start-9': data.images.length == 2}" v-for="(image, index) in data.images" :key="index">
                <Media :data="image" class="cursor-pointer" @click="openGallery(index)"/>
            </div>
        </div>

        <transition name="fade">
            <div class="gallery-modal fixed z-[999999999999] top-0 left-0 z-100 w-full h-full bg-white flex justify-center items-center" v-if="showGallery">
                <div class="relative h-full w-full py-21 px-4 md:py-21 md:px-22">
                    <Media :data="data.images[galleryIndex]" class="w-full h-full object-contain modal-image"/>
                    <button @click="showGallery = false" class="absolute top-0 right-0 mt-6 mr-6 md:mt-14 md:mr-14 text-black text-2xl block">
                        <ElementButton :title="'Luk'" :englishTitle="'Close'" :noIcon="true"/>
                    </button>

                    <button @click="galleryIndex = (galleryIndex - 1 + data.images.length) % data.images.length" class="absolute z-10 md:top-1/2 bottom-12 md:bottom-auto md:-translate-y-1/2 left-0 ml-4 md:ml-14 block">
                        <ElementButton class="rotate-180"/>
                    </button>

                    <button @click="galleryIndex = (galleryIndex + 1) % data.images.length" class="absolute z-10 md:top-1/2 md:-translate-y-1/2 bottom-12 md:bottom-auto right-0 mr-4 md:mr-14 block">
                        <ElementButton/>
                    </button>

                    <p class="absolute bottom-12 md:bottom-9 left-0 w-full text-center text-sm-serif">{{galleryIndex + 1}}/{{data.images.length}}</p>
                </div>
            </div>
        </transition>
    </div>
</template>

<script setup>
const props = defineProps({
    data: {
        type: Object,
        default: {images: [
            {
                "url": "https://sydhavnteater:8890/assets/gallery-3.jpg",
                "width": 1232,
                "height": 1232,
                "mimeType": "image/jpeg",
                "title": "Gallery 3"
            },
            {
                "url": "https://sydhavnteater:8890/assets/gallery-2.jpg",
                "width": 1144,
                "height": 1662,
                "mimeType": "image/jpeg",
                "title": "Gallery 2"
            }
        ]}
    }
})

const showGallery = ref(false)
const galleryIndex = ref(0)

watch(showGallery, () => {
    if (showGallery.value) {
		document.body.style.paddingRight = `${window.innerWidth - document.documentElement.clientWidth}px`;
		document.body.style.overflow = 'hidden';
	} else {
		document.body.style.overflow = '';
		document.body.style.paddingRight = '';
	}
})

const openGallery = (index) => {
    galleryIndex.value = index
    showGallery.value = true
}

const keyEvent = (e) => {
    if (showGallery.value) {
        if (e.key === 'Escape') {
            showGallery.value = false
        } else if (e.key === 'ArrowRight') {
            galleryIndex.value = (galleryIndex.value + 1) % props.data.images.length
        } else if (e.key === 'ArrowLeft') {
            galleryIndex.value = (galleryIndex.value - 1 + props.data.images.length) % props.data.images.length
        }
    }
}

onMounted(() => {
    window.addEventListener('keydown', keyEvent)
})

onBeforeUnmount(() => {
    window.removeEventListener('keydown', keyEvent)
})
</script>

<style lang="scss" scoped>
.modal-image :deep(img) {
    @apply w-full h-full object-contain;
}

.gallery-modal {
    z-index: 999999999999;
    touch-action: manipulation;
}
</style>